function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHolisticsLink = function SvgHolisticsLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20 15.585a8.9 8.9 0 0 1-2.565 3.424 8.84 8.84 0 0 1-8.134 1.615 8.85 8.85 0 0 1-3.673-2.186 8.87 8.87 0 0 1-2.478-7.932A8.9 8.9 0 0 1 4.922 6.61 8.85 8.85 0 0 1 8.31 4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21 12a9 9 0 0 0-9-9v9z",
    fill: props.fill
  }));
};
export default SvgHolisticsLink;